var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [_vm._v("Visita")]),
          _vm._v(" "),
          _c("label", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "N",
                    expression: "estado === 'N'"
                  }
                ],
                staticClass: "noti-info"
              },
              [_c("strong", [_vm._v("NUEVA")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "I",
                    expression: "estado === 'I'"
                  }
                ],
                staticClass: "noti-secondary"
              },
              [_c("strong", [_vm._v("INICIADA")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "A",
                    expression: "estado === 'A'"
                  }
                ],
                staticClass: "noti-danger"
              },
              [_c("strong", [_vm._v("ANULADA")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "P",
                    expression: "estado === 'P'"
                  }
                ],
                staticClass: "noti-primary"
              },
              [_c("strong", [_vm._v("PENDIENTE")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "F",
                    expression: "estado === 'F'"
                  }
                ],
                staticClass: "noti-success"
              },
              [_c("strong", [_vm._v("FINALIZADA")])]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.puede_consultar_visitas ||
                      _vm.puede_editar_visita ||
                      _vm.puede_eliminar_visita,
                    expression:
                      "\n            puede_consultar_visitas ||\n            puede_editar_visita ||\n            puede_eliminar_visita\n          "
                  }
                ],
                staticClass: "btn-info btn--bigger",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main" }, [
        _c("div", { staticClass: "layout__main-form" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "fecha",
                            locale: "es",
                            "no-label": "",
                            disabled:
                              (_vm.estado !== "N" && _vm.estado !== "P") ||
                              _vm.selectedRuta != null,
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD HH:mm",
                            formatted: "YYYY-MM-DD HH:mm",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fecha,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha", $$v)
                            },
                            expression: "form.fecha"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Fecha")]),
                        _vm._v(" "),
                        _vm.errores.fecha
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.fecha[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-8" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "textarea-field",
                        {
                          attrs: {
                            placeholder: "Escriba una observación...",
                            id: "observacion",
                            readonly: _vm.estado !== "N" && _vm.estado !== "P"
                          },
                          model: {
                            value: _vm.form.observacion,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "observacion", $$v)
                            },
                            expression: "form.observacion"
                          }
                        },
                        [
                          _c("span", [_vm._v("Observación")]),
                          _vm._v(" "),
                          _vm.errores.observacion
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.observacion[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-field select2",
                      class: {
                        "select2--disabled":
                          _vm.estado !== "N" && _vm.estado !== "P"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              id: "ruta",
                              options: _vm.rutas,
                              label: "descripcion",
                              placeholder: "Seleccione..."
                            },
                            on: {
                              search: _vm.onSearchRutas,
                              input: _vm.inputRuta
                            },
                            model: {
                              value: _vm.selectedRuta,
                              callback: function($$v) {
                                _vm.selectedRuta = $$v
                              },
                              expression: "selectedRuta"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "ruta" } }, [
                            _vm._v("Ruta")
                          ]),
                          _vm._v(" "),
                          _vm.errores.ruta_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.ruta_id[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-field select2",
                      class: {
                        "select2--disabled":
                          _vm.estado !== "N" && _vm.estado !== "P"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              placeholder: "Seleccione...",
                              options: _vm.supervisores,
                              id: "supervisor",
                              name: "supervisor",
                              label: "nombre"
                            },
                            on: {
                              input: _vm.inputSupervisor,
                              search: _vm.searchSupervisores
                            },
                            model: {
                              value: _vm.selectedSupervisor,
                              callback: function($$v) {
                                _vm.selectedSupervisor = $$v
                              },
                              expression: "selectedSupervisor"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "supervisor" } }, [
                            _vm._v("Supervisor*")
                          ]),
                          _vm._v(" "),
                          _vm.errores.supervisor_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.supervisor_id[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-field select2",
                      class: {
                        "select2--disabled":
                          _vm.estado !== "N" && _vm.estado !== "P"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              placeholder: "Seleccione...",
                              options: _vm.verificadores,
                              id: "verificador",
                              name: "verificador",
                              label: "descripcion"
                            },
                            on: {
                              input: _vm.inputVerificador,
                              search: _vm.searchVerificadores
                            },
                            model: {
                              value: _vm.selectedVerificador,
                              callback: function($$v) {
                                _vm.selectedVerificador = $$v
                              },
                              expression: "selectedVerificador"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "verificador" } }, [
                            _vm._v("Verificador*")
                          ]),
                          _vm._v(" "),
                          _vm.errores.verificador_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.supervisor_id[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-field select2",
                      class: {
                        "select2--disabled":
                          _vm.estado !== "N" && _vm.estado !== "P"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              placeholder: "Seleccione...",
                              options: _vm.recaudadores,
                              id: "recaudador",
                              name: "recaudador",
                              label: "nombre"
                            },
                            on: {
                              input: _vm.inputRecaudador,
                              search: _vm.searchRecaudadores
                            },
                            model: {
                              value: _vm.selectedRecaudador,
                              callback: function($$v) {
                                _vm.selectedRecaudador = $$v
                              },
                              expression: "selectedRecaudador"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "recaudador" } }, [
                            _vm._v("Recaudador*")
                          ]),
                          _vm._v(" "),
                          _vm.errores.recaudador_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.recaudador_id[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field select" }, [
                    _c("div", { staticClass: "select-field" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.dia_cobro,
                              expression: "form.dia_cobro"
                            }
                          ],
                          attrs: {
                            disabled: _vm.estado !== "N" && _vm.estado !== "P",
                            id: "dia_cobro"
                          },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.form,
                                "dia_cobro",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { disabled: "", value: "" } }, [
                            _vm._v("Seleccione...")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "1" } }, [
                            _vm._v("Lunes")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "2" } }, [
                            _vm._v("Martes")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "3" } }, [
                            _vm._v("Miércoles")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "4" } }, [
                            _vm._v("Jueves")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "5" } }, [
                            _vm._v("Viernes")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "6" } }, [
                            _vm._v("Sábado")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "7" } }, [
                            _vm._v("Domingo")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "dia_cobro" } }, [
                        _vm._v("Día de cobro")
                      ]),
                      _vm._v(" "),
                      _vm.errores.dia_cobro
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.dia_cobro[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.form.descripcion_movimiento != "" &&
                          _vm.form.descripcion_movimiento != null,
                        expression:
                          "\n                form.descripcion_movimiento != '' &&\n                form.descripcion_movimiento != null\n              "
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-field" },
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              id: "descripcion_movimiento",
                              readonly: ""
                            },
                            model: {
                              value: _vm.form.descripcion_movimiento,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "descripcion_movimiento",
                                  $$v
                                )
                              },
                              expression: "form.descripcion_movimiento"
                            }
                          },
                          [_c("span", [_vm._v("Movimiento")])]
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card mt-2" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            id: "almuerzo_inicial",
                            vMoney: "",
                            readonly:
                              _vm.estado !== "N" &&
                              _vm.estado !== "P" &&
                              _vm.estado !== "I",
                            format: _vm.money
                          },
                          model: {
                            value: _vm.form.almuerzo_inicial,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "almuerzo_inicial", $$v)
                            },
                            expression: "form.almuerzo_inicial"
                          }
                        },
                        [_c("span", [_vm._v("Almuerzo inicial")])]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            id: "peaje_inicial",
                            readonly:
                              _vm.estado !== "N" &&
                              _vm.estado !== "P" &&
                              _vm.estado !== "I",
                            vMoney: "",
                            format: _vm.money
                          },
                          model: {
                            value: _vm.form.peaje_inicial,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "peaje_inicial", $$v)
                            },
                            expression: "form.peaje_inicial"
                          }
                        },
                        [_c("span", [_vm._v("Peaje inicial")])]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            id: "combustible_inicial",
                            readonly:
                              _vm.estado !== "N" &&
                              _vm.estado !== "P" &&
                              _vm.estado !== "I",
                            vMoney: "",
                            format: _vm.money
                          },
                          model: {
                            value: _vm.form.combustible_inicial,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "combustible_inicial", $$v)
                            },
                            expression: "form.combustible_inicial"
                          }
                        },
                        [_c("span", [_vm._v("Combustible inicial")])]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            id: "otros_inicial",
                            readonly:
                              _vm.estado !== "N" &&
                              _vm.estado !== "P" &&
                              _vm.estado !== "I",
                            vMoney: "",
                            format: _vm.money
                          },
                          model: {
                            value: _vm.form.otros_inicial,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "otros_inicial", $$v)
                            },
                            expression: "form.otros_inicial"
                          }
                        },
                        [_c("span", [_vm._v("Otros valores iniciales")])]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            id: "total_rubros",
                            value: _vm.totalRubros,
                            readonly: "",
                            vMoney: "",
                            format: _vm.money
                          }
                        },
                        [_c("span", [_vm._v("Total de rubros iniciales")])]
                      )
                    ],
                    1
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card mt-2" }, [
            _c("div", { staticClass: "card__title" }, [
              _c("h5", [_vm._v("Vendedores")]),
              _vm._v(" "),
              _c("div", { staticClass: "card__controls" }, [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          id: "vendedor",
                          name: "vendedor",
                          options: _vm.vendedores,
                          label: "descripcion"
                        },
                        on: {
                          input: _vm.inputVendedor,
                          search: _vm.searchVendedores
                        },
                        model: {
                          value: _vm.selectedVendedor,
                          callback: function($$v) {
                            _vm.selectedVendedor = $$v
                          },
                          expression: "selectedVendedor"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "vendedor" } }, [
                        _vm._v("Vendedor")
                      ])
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "table-responsive" }, [
                _c("table", [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.form.vendedores, function(vendedor, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(vendedor.descripcion) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(vendedor.direccion) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(vendedor.telefonos) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "button",
                              {
                                staticClass: "btn-danger btn--text",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.eliminarVendedor(index)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-trash" })]
                            )
                          ])
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.vendedores.length == 0,
                              expression: "form.vendedores.length == 0"
                            }
                          ]
                        },
                        [_vm._m(3)]
                      )
                    ],
                    2
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.selectedRuta != null,
                  expression: "selectedRuta != null"
                }
              ],
              staticClass: "card mt-2"
            },
            [
              _c("div", { staticClass: "card__title" }, [
                _c("h5", [_vm._v("Ítems")]),
                _vm._v(" "),
                _c("div", { staticClass: "card__controls" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      { staticClass: "form-field" },
                      [
                        _c("input-field", {
                          attrs: {
                            id: "referencia_movimiento",
                            readonly: _vm.form.items.length > 0,
                            placeholder: "Indique un movimiento..."
                          },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.importar.apply(null, arguments)
                            }
                          },
                          model: {
                            value: _vm.form.referencia_movimiento,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "referencia_movimiento", $$v)
                            },
                            expression: "form.referencia_movimiento"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.items.length === 0,
                            expression: "form.items.length === 0"
                          }
                        ],
                        staticClass: "btn-success btn--text",
                        attrs: { type: "button" },
                        on: { click: _vm.importar }
                      },
                      [_c("i", { staticClass: "fa fa-download" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.items.length > 0,
                            expression: "form.items.length > 0"
                          }
                        ],
                        staticClass: "btn-danger btn--text",
                        attrs: {
                          disabled: _vm.estado !== "N" && _vm.estado !== "P",
                          type: "button"
                        },
                        on: { click: _vm.quitarItems }
                      },
                      [_c("i", { staticClass: "fa fa-times" })]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card__content" },
                [
                  _c("items-visitas", {
                    attrs: { editable: _vm.estado == "N" || _vm.estado == "P" },
                    model: {
                      value: _vm.form.items,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "items", $$v)
                      },
                      expression: "form.items"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.estado !== "N",
                  expression: "estado !== 'N'"
                }
              ],
              staticClass: "card mt-2"
            },
            [
              _c(
                "div",
                { staticClass: "card__content" },
                [
                  _c("items-adicionales", {
                    attrs: {
                      ruta_id: _vm.form.ruta_id,
                      editable:
                        _vm.estado == "N" ||
                        _vm.estado == "P" ||
                        _vm.estado === "I",
                      visitaId: _vm.id
                    },
                    model: {
                      value: _vm.form.movimientosAdicionales,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "movimientosAdicionales", $$v)
                      },
                      expression: "form.movimientosAdicionales"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card mt-2" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            id: "fecha_inicio",
                            placeholder: "YYYY-MM-DD HH:mm:ss",
                            readonly: ""
                          },
                          model: {
                            value: _vm.form.fecha_inicio,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_inicio", $$v)
                            },
                            expression: "form.fecha_inicio"
                          }
                        },
                        [_c("span", [_vm._v("Fecha de inicio")])]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "textarea-field",
                          {
                            attrs: {
                              placeholder: "Observación...",
                              id: "observacion_inicio",
                              readonly: ""
                            },
                            model: {
                              value: _vm.form.observacion_inicio,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "observacion_inicio", $$v)
                              },
                              expression: "form.observacion_inicio"
                            }
                          },
                          [
                            _c("span", [_vm._v("Observación de inicio")]),
                            _vm._v(" "),
                            _vm.errores.observacion_inicio
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores.observacion_inicio[0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.form.latitud_inicio != "" &&
                                  _vm.form.longitud_inicio != "",
                                expression:
                                  "\n                      form.latitud_inicio != '' && form.longitud_inicio != ''\n                    "
                              }
                            ],
                            staticClass: "btn-info btn--text",
                            attrs: { type: "button" },
                            on: { click: _vm.verCoordenadasInicio }
                          },
                          [_c("i", { staticClass: "fa fa-eye" })]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "textarea-field",
                        {
                          attrs: {
                            placeholder: "Dirección...",
                            id: "direccion_inicio",
                            readonly: ""
                          },
                          model: {
                            value: _vm.form.direccion_inicio,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "direccion_inicio", $$v)
                            },
                            expression: "form.direccion_inicio"
                          }
                        },
                        [
                          _c("span", [_vm._v("Dirección de inicio")]),
                          _vm._v(" "),
                          _vm.errores.direccion_inicio
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.errores.direccion_inicio[0])
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            id: "fecha_fin",
                            placeholder: "YYYY-MM-DD HH:mm:ss",
                            readonly: ""
                          },
                          model: {
                            value: _vm.form.fecha_fin,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_fin", $$v)
                            },
                            expression: "form.fecha_fin"
                          }
                        },
                        [_c("span", [_vm._v("Fecha de fin")])]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "textarea-field",
                          {
                            attrs: {
                              placeholder: "Escriba una observación...",
                              id: "observacion_fin",
                              readonly: ""
                            },
                            model: {
                              value: _vm.form.observacion_fin,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "observacion_fin", $$v)
                              },
                              expression: "form.observacion_fin"
                            }
                          },
                          [
                            _c("span", [_vm._v("Observación de fin")]),
                            _vm._v(" "),
                            _vm.errores.observacion_fin
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.errores.observacion_fin[0])
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.form.latitud_fin != "" &&
                                  _vm.form.longitud_fin != "",
                                expression:
                                  "form.latitud_fin != '' && form.longitud_fin != ''"
                              }
                            ],
                            staticClass: "btn-info btn--text",
                            attrs: { type: "button" },
                            on: { click: _vm.verCoordenadasFin }
                          },
                          [_c("i", { staticClass: "fa fa-eye" })]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "textarea-field",
                        {
                          attrs: {
                            placeholder: "Dirección...",
                            id: "direccion_fin",
                            readonly: ""
                          },
                          model: {
                            value: _vm.form.direccion_fin,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "direccion_fin", $$v)
                            },
                            expression: "form.direccion_fin"
                          }
                        },
                        [
                          _c("span", [_vm._v("Dirección de fin")]),
                          _vm._v(" "),
                          _vm.errores.direccion_fin
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.direccion_fin[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            id: "fecha_cancelacion",
                            placeholder: "YYYY-MM-DD HH:mm:ss",
                            readonly: ""
                          },
                          model: {
                            value: _vm.form.fecha_cancelacion,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_cancelacion", $$v)
                            },
                            expression: "form.fecha_cancelacion"
                          }
                        },
                        [_c("span", [_vm._v("Fecha de cancelación")])]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "textarea-field",
                          {
                            attrs: {
                              placeholder: "Escriba una observación...",
                              id: "observacion_cancelacion",
                              readonly: ""
                            },
                            model: {
                              value: _vm.form.observacion_cancelacion,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "observacion_cancelacion",
                                  $$v
                                )
                              },
                              expression: "form.observacion_cancelacion"
                            }
                          },
                          [
                            _c("span", [_vm._v("Observación de cancelación")]),
                            _vm._v(" "),
                            _vm.errores.observacion_cancelacion
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores.observacion_cancelacion[0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.form.latitud_cancelacion != "" &&
                                  _vm.form.longitud_cancelacion != "",
                                expression:
                                  "\n                      form.latitud_cancelacion != '' &&\n                      form.longitud_cancelacion != ''\n                    "
                              }
                            ],
                            staticClass: "btn-info btn--text",
                            attrs: { type: "button" },
                            on: { click: _vm.verCoordenadasCancelacion }
                          },
                          [_c("i", { staticClass: "fa fa-eye" })]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "textarea-field",
                        {
                          attrs: {
                            placeholder: "Dirección...",
                            id: "direccion_fin",
                            readonly: ""
                          },
                          model: {
                            value: _vm.form.direccion_cancelacion,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "direccion_cancelacion", $$v)
                            },
                            expression: "form.direccion_cancelacion"
                          }
                        },
                        [
                          _c("span", [_vm._v("Dirección de cancelación")]),
                          _vm._v(" "),
                          _vm.errores.direccion_cancelacion
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errores.direccion_cancelacion[0]
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c(
                    "div",
                    { staticStyle: { height: "350px" } },
                    [
                      _c(
                        "l-map",
                        {
                          staticStyle: { height: "100%", width: "100%" },
                          attrs: { zoom: _vm.zoom, center: _vm.center },
                          on: {
                            "update:zoom": _vm.zoomUpdated,
                            "update:center": _vm.centerUpdated
                          }
                        },
                        [
                          _c("l-tile-layer", { attrs: { url: _vm.url } }),
                          _vm._v(" "),
                          _vm.latLngInicio != null
                            ? _c("l-marker", {
                                attrs: {
                                  icon: _vm.markerIcon,
                                  "lat-lng": _vm.latLngInicio
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.latLngFin != null
                            ? _c("l-marker", {
                                attrs: {
                                  icon: _vm.markerIcon,
                                  "lat-lng": _vm.latLngFin
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.latLngCancelacion != null
                            ? _c("l-marker", {
                                attrs: {
                                  icon: _vm.markerIcon,
                                  "lat-lng": _vm.latLngCancelacion
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__main-buttons" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (_vm.estado === "N" && _vm.puede_crear_visita) ||
                        ((_vm.estado === "P" || _vm.estado === "I") &&
                          _vm.puede_editar_visita),
                      expression:
                        "\n              (estado === 'N' && puede_crear_visita) ||\n              ((estado === 'P' || estado === 'I') && puede_editar_visita)\n            "
                    }
                  ],
                  staticClass: "btn-success",
                  attrs: { type: "button" },
                  on: { click: _vm.guardar }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _c("span", [_vm._v("Guardar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-primary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.nueva }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _c("span", [_vm._v("Nueva")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado === "F",
                      expression: "estado === 'F'"
                    }
                  ],
                  staticClass: "btn-warning btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.restablecerInicio }
                },
                [
                  _c("i", { staticClass: "fa fa-refresh" }),
                  _c("span", [_vm._v("Restablecer inicio")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N" && _vm.estado !== "A",
                      expression: "estado !== 'N' && estado !== 'A'"
                    }
                  ],
                  staticClass: "btn-warning btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.verRubros }
                },
                [
                  _c("i", { staticClass: "fa fa-money" }),
                  _c("span", [_vm._v("Rubros finales")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-success btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.imprimir }
                },
                [
                  _c("i", { staticClass: "fa fa-print" }),
                  _c("span", [_vm._v("Imprimir")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-secondary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.imprimirResumen }
                },
                [
                  _c("i", { staticClass: "fa fa-print" }),
                  _c("span", [_vm._v("Imprimir resumen")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado === "P" && _vm.puede_eliminar_visita,
                      expression: "estado === 'P' && puede_eliminar_visita"
                    }
                  ],
                  staticClass: "btn-danger btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.anular }
                },
                [
                  _c("i", { staticClass: "fa fa-ban" }),
                  _c("span", [_vm._v("Anular")])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "80%",
            height: "auto",
            name: "listaVisitas",
            scrollable: "",
            adaptive: "",
            reset: "",
            resizable: ""
          }
        },
        [
          _c("lista-visitas", {
            attrs: { bodegas: _vm.bodegas },
            on: {
              seleccionar: _vm.selectedVisita,
              cerrar: _vm.cerrarListaVisitas
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "rubrosVisita",
            height: "auto",
            width: "90%",
            scrollable: "",
            adaptive: "",
            reset: "",
            resizable: ""
          }
        },
        [
          _c("rubros-visita", {
            attrs: { visitaId: _vm.id },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("rubrosVisita")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información de la visita")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Rubros iniciales")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Nombre")]),
        _vm._v(" "),
        _c("th", [_vm._v("Dirección")]),
        _vm._v(" "),
        _c("th", [_vm._v("Teléfonos")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("strong", [_vm._v("Debe seleccionar una ruta con vendedores.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información adicional")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-069a48ad", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-069a48ad","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/visitas/Visita.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-069a48ad","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/visitas/Visita.vue
// module chunks = 0